import {
  FETCH_PROJECT_FILES,
  FETCH_PROJECT_FILES_START,
  FETCH_PROJECT_FILES_SUCCESS,
  FETCH_PROJECT_FILES_ERROR,
  POST_FILE_REMOVE,
  POST_FILE_REMOVE_START,
  POST_FILE_REMOVE_SUCCESS,
  POST_FILE_REMOVE_ERROR,
  PATCH_FILE_NAME,
  PATCH_FILE_NAME_START,
  PATCH_FILE_NAME_SUCCESS,
  PATCH_FILE_NAME_ERROR,
  PATCH_FILE_DESCRIPTION,
  PATCH_FILE_DESCRIPTION_START,
  PATCH_FILE_DESCRIPTION_SUCCESS,
  PATCH_FILE_DESCRIPTION_ERROR,
  PATCH_FILE_INTERNAL,
  PATCH_FILE_INTERNAL_START,
  PATCH_FILE_INTERNAL_SUCCESS,
  PATCH_FILE_INTERNAL_ERROR,
  FETCH_FILE,
  FETCH_FILE_START,
  FETCH_FILE_SUCCESS,
  FETCH_FILE_ERROR,
  FETCH_FILE_FOR_PREVIEW,
  FETCH_FILE_FOR_PREVIEW_START,
  FETCH_FILE_FOR_PREVIEW_SUCCESS,
  FETCH_FILE_FOR_PREVIEW_ERROR,
} from './constants'

const fetchProjectFiles = (id) => ({ type: FETCH_PROJECT_FILES, id })
const fetchProjectFilesStart = () => ({ type: FETCH_PROJECT_FILES_START })
const fetchProjectFilesSucess = (id) => ({ type: FETCH_PROJECT_FILES_SUCCESS })
const fetchProjectFilesError = (error) => ({ type: FETCH_PROJECT_FILES_ERROR, error })

const postFileRemove = (id) => ({ type: POST_FILE_REMOVE, id })
const postFileRemoveStart = () => ({ type: POST_FILE_REMOVE_START })
const postFileRemoveSuccess = () => ({ type: POST_FILE_REMOVE_SUCCESS })
const postFileRemoveError = (error) => ({ type: POST_FILE_REMOVE_ERROR, error })

const patchFileName = (id, name) => ({ type: PATCH_FILE_NAME, id, name })
const patchFileNameStart = () => ({ type: PATCH_FILE_NAME_START })
const patchFileNameSuccess = () => ({ type: PATCH_FILE_NAME_SUCCESS })
const patchFileNameError = (error) => ({ type: PATCH_FILE_NAME_ERROR, error })

const patchFileDescription = (id, description) => ({ type: PATCH_FILE_DESCRIPTION, id, description })
const patchFileDescriptionStart = () => ({ type: PATCH_FILE_DESCRIPTION_START })
const patchFileDescriptionSuccess = () => ({ type: PATCH_FILE_DESCRIPTION_SUCCESS })
const patchFileDescriptionError = (error) => ({ type: PATCH_FILE_DESCRIPTION_ERROR, error })

const patchFileInternal = (id, internal) => ({ type: PATCH_FILE_INTERNAL, id, internal })
const patchFileInternalStart = () => ({ type: PATCH_FILE_INTERNAL_START })
const patchFileInternalSuccess = () => ({ type: PATCH_FILE_INTERNAL_SUCCESS })
const patchFileInternalError = (error) => ({ type: PATCH_FILE_INTERNAL_ERROR, error })

const fetchFile = (id, name) => ({ type: FETCH_FILE, id, name })
const fetchFileStart = () => ({ type: FETCH_FILE_START })
const fetchFileSuccess = () => ({ type: FETCH_FILE_SUCCESS })
const fetchFileError = (error) => ({ type: FETCH_FILE_ERROR, error })

const fetchFileForPreview = (id, name) => ({ type: FETCH_FILE_FOR_PREVIEW, id, name })
const fetchFileForPreviewStart = () => ({ type: FETCH_FILE_FOR_PREVIEW_START })
const fetchFileForPreviewSuccess = () => ({ type: FETCH_FILE_FOR_PREVIEW_SUCCESS })
const fetchFileForPreviewError = (error) => ({ type: FETCH_FILE_FOR_PREVIEW_ERROR, error })

export {
  fetchProjectFiles,
  fetchProjectFilesStart,
  fetchProjectFilesSucess,
  fetchProjectFilesError,
  postFileRemove,
  postFileRemoveStart,
  postFileRemoveSuccess,
  postFileRemoveError,
  patchFileName,
  patchFileNameStart,
  patchFileNameSuccess,
  patchFileNameError,
  patchFileDescription,
  patchFileDescriptionStart,
  patchFileDescriptionSuccess,
  patchFileDescriptionError,
  patchFileInternal,
  patchFileInternalStart,
  patchFileInternalSuccess,
  patchFileInternalError,
  fetchFile,
  fetchFileStart,
  fetchFileSuccess,
  fetchFileError,
  fetchFileForPreview,
  fetchFileForPreviewStart,
  fetchFileForPreviewSuccess,
  fetchFileForPreviewError,
}
